import React from 'react';

import CSS from './styles.scss';
import Card from 'Shared/Card';


const AnnotationListViews = ({ deleteHighlight, displayAnnotations, toggle }) => {
  if (displayAnnotations.length === 0) {
    return (
      <div id="annotationList" className={ CSS['container'] } data-test-id='annotation-list'>
        <div className={ CSS['empty-message-box'] } data-test-id="empty-notebook-message-box" tabIndex="0">
          <span className={ CSS['empty-message'] }>Empty Notebook</span>
          <span className={ CSS['empty-message'] }>Add a highlight or note in your ebook and look for them here.</span>
        </div>
      </div>
    );
  }

  return (
    <div id="annotationList" className={ CSS['container'] }>
      {
        displayAnnotations.map((highlight, i) => {
          return <Card key={i}
            highlight={ highlight }
            deleteHighlight={ deleteHighlight }
            toggle={ toggle }
          />
        })
      }
    </div>
  );
};

AnnotationListViews.propTypes = {};


export default AnnotationListViews;

